export const API_ENDPOINT = 'areas-of-advice';


// WEBPACK FOOTER //
// ./src/state/modules/areas-of-advice/configurations/endpoints.js